import React from "react";
import { Navigate } from "react-router-dom";

const UnAuthenticatedRoute = ({ children, redirectTo }) => {
  const auth = JSON.parse(localStorage.getItem("userDetail"));

  const isAuthenticated = auth && auth.token;

  return isAuthenticated ? children : <Navigate to={redirectTo} />;
};

export default UnAuthenticatedRoute;
